module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section06_01_american-village-682564dc24f887f257cf533316bd9a55.jpg";